export const STATE_PROP = 'global'
